// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"zP-z","categoryName":"AP-z","categoryNameSearchHeader":"BP-z","categoryContent":"CP-z","bottomAligned":"DP-z","image":"EP-z","imageNoBackground":"FP-z"};